<template>
	<div class="container page">
		<!-- :title="$t('other.withdraw')" -->
		<van-nav-bar :title="$t('textS9')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			<template #right>
				<div class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("other.withdraw_records")}}
				</div>
			</template>
		</van-nav-bar>
		<div class="main">
			<div class="withdrawMoney">
				<span>{{$t("other.withdraw_amount")}}</span>
				<div class="money">
					<div class="moneyNumber">
						<van-field v-model="withdraw_money" type="number" />
					</div>
					<span class="all" @click="allMoeny()">{{$t("other.all")}}</span>
				</div>
				<div class="information">
					<div class="description">
						<van-popover v-model="showPopover" trigger="click">
							<div class="popover-body" style="padding: 10px;">
								<p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}
								</p>
								<p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
								<p>3.{{$t("withdraw.with_tip")}}</p>
							</div>
						</van-popover>
					</div>

					<div class="balance">
						<span>{{$t("other.balance")}}：</span>
						<span class="number">{{ user_money }}</span>
					</div>
				</div>
			</div>
			<van-button class="withdraw_btn" type="default"
				@click="doWithdraw()">{{$t("other.confirm_withdraw")}}</van-button>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showPopover: false,
				withdraw_money: "",
				user_money: '',
				withdrawRole: {}
			};
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code == 1) {
						this.user_money = res.data.user_money;
					} else {
						this.$toast(res.msg);
					}
				})
			},
			//全部
			allMoeny() {
				this.withdraw_money = this.user_money;
			},
			doWithdraw() {
				this.$http({
					method: 'post',
					data: {
						amount: this.withdraw_money
					},
					url: 'withdrawSubmit'
				}).then(res => {
					if (res.code == 1) {
						this.$toast(res.msg);
						this.getUserInfo();
						return
					}
					this.$toast(res.msg);
				})
			},
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.nav-right {
		width: 150px;
	}

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}

	.container p {
		padding: 0 15px;
		margin-top: 15px;
		font-size: 30px;
		color: #dc2037;
	}

	.container .main {
		display: flex;
		flex-direction: column;
		background-color: #f2f2f5;
		height: calc(100% - 50px);
		position: relative;
	}

	.container .main .withdrawMoney {
		display: flex;
		flex-direction: column;
		color: #000;
		padding: 0 20px;
		white-space: nowrap;
		font-size: 35px;
		background-color: #fff;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .money {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		border-bottom: 1px solid #f2f2f5;
	}

	.container .main .withdrawMoney .money .moneyNumber {
		font-size: 50px;
		display: flex;
		flex-direction: row;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .money .all {
		color: #d10404;
	}

	.container .main .withdrawMoney .money .moneyNumber .van-cell {
		font-size: 50px;
		padding: 0 !important;
	}

	.container .main .withdrawMoney .information {
		padding-bottom: 30px;
	}

	.container .main .withdrawMoney .information .description {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding: 10px 0;
	}

	.container .main .withdrawMoney span {
		padding: 10px 0;
	}

	.container .main .withdrawMoney .information .balance .number {
		color: #d10404;
	}

	.withdraw_btn {
		margin: 20px 30px 0;
		padding: 20px 0;
		line-height: 1.22667rem;
		border-radius: 50px;
		color: #fff;
		font-size: 30px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(90deg, #e6c3a1, #7e5678);
	}
</style>